{
  "lastUpdatedAt": "2026-10-20T08:15:53.512Z",
  "lastFetchAttemptAt": "2026-10-20T08:15:53.512Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}